// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1nH-T","inputWrap":"Table_inputWrap__26JsS","col":"Table_col__1uFTs","bmiTooltip":"Table_bmiTooltip__2V3oi"};